import type { VideoItem } from '@/mocks/videos';

export function formatCount(value: number): string {
  if (value >= 100000000) return `${(value / 100000000).toFixed(1)}亿`;
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return `${value}`;
}

export interface FilterState {
  type?: string;
  subType: string;
  region: string;
  year: string;
  popularity?: string;
  keyword?: string;
}

export function filterVideos(list: VideoItem[], filters: FilterState): VideoItem[] {
  const keyword = (filters.keyword || '').trim().toLowerCase();
  return list.filter((item) => {
    if (filters.type && filters.type !== 'all' && item.type !== filters.type) return false;
    if (filters.subType && filters.subType !== '全部' && item.subType !== filters.subType) return false;
    if (filters.region && filters.region !== '全部' && item.region !== filters.region) return false;
    if (filters.popularity && filters.popularity !== '全部') {
      if (filters.popularity === '热门' && item.views < 15000000) return false;
      if (filters.popularity === '高分' && item.rating < 8.5) return false;
    }
    if (filters.year && filters.year !== '全部') {
      if (filters.year === '更早') {
        if (item.year >= 2021) return false;
      } else if (`${item.year}` !== filters.year) {
        return false;
      }
    }
    if (keyword) {
      const haystack = [
        item.title,
        item.description,
        item.subType,
        item.region,
        item.director,
        ...item.genres,
        ...item.cast,
      ]
        .join(' ')
        .toLowerCase();
      if (!haystack.includes(keyword)) return false;
    }
    return true;
  });
}

export function sortVideos(list: VideoItem[], key: string): VideoItem[] {
  const sorted = [...list];
  if (key === 'popular') {
    return sorted.sort((a, b) => b.views - a.views);
  }
  if (key === 'rating') {
    return sorted.sort((a, b) => b.rating - a.rating);
  }
  return sorted.sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1));
}

export function getRelated(video: VideoItem, list: VideoItem[], count = 6): VideoItem[] {
  return list
    .filter((item) => item.id !== video.id)
    .map((item) => {
      let score = 0;
      if (item.type === video.type) score += 3;
      if (item.subType === video.subType) score += 2;
      score += item.genres.filter((g) => video.genres.includes(g)).length * 2;
      score += item.cast.filter((c) => video.cast.includes(c)).length * 2;
      if (item.region === video.region) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views)
    .slice(0, count)
    .map((entry) => entry.item);
}

export function getLatest(list: VideoItem[], count = 8): VideoItem[] {
  return sortVideos(list, 'latest').slice(0, count);
}

export function getPopular(list: VideoItem[], count = 8): VideoItem[] {
  return sortVideos(list, 'popular').slice(0, count);
}